import {getMessages} from 'app/store/constants';

export const ACTIVITY_UNDO = getMessages().getText('activity.undo');
export const ACTIVITY_TOOLTIP_MORE = getMessages().getText('activity.undo');
